import { call, select, put, takeLatest } from 'redux-saga/effects';
import { GET_AGENTS, GET_CITIES } from 'store/geolocAgent/constants';
import {
  setAgents,
  getAgentsFailed,
  getCitiesSuccess,
  getCitiesFailed,
} from 'store/geolocAgent/actions';
import { getMyAgentApi, getCitiesApi } from 'store/geolocAgent/api';
import { getSelectedTabSelector } from 'store/global/selectors';

export function* getAgents() {
  try {
    const typeAgents = yield select(getSelectedTabSelector);
    const response = yield call(getMyAgentApi, {
      type: typeAgents,
    });
    if (response.data.success) {
      yield put(setAgents(response.data.data));
    }
  } catch (error) {
    yield put(getAgentsFailed(error));
  }
}
export function* watchGetAgents() {
  yield takeLatest(GET_AGENTS, getAgents);
}

export function* getCities({
  payload,
}: {
  type: typeof GET_CITIES;
  payload: string;
}) {
  try {
    const response = yield call(getCitiesApi, payload);
    yield put(getCitiesSuccess(response.data.data));
  } catch (err) {
    yield put(getCitiesFailed(err));
  }
}

export function* watchGetCities() {
  yield takeLatest(GET_CITIES, getCities);
}

export default [watchGetAgents, watchGetCities];
